// extracted by mini-css-extract-plugin
export default {"dividerForm":"AdvancedOption_dividerForm__DRBU4","columnsGap":"AdvancedOption_columnsGap__HfCKg"};